import React from 'react';
import styled from 'styled-components';
import DefaultLink from '../../Atoms/Link';
import { IconSMArrowRight } from '../../Atoms/Icon';

const Component = styled.div`
  a {
    display: flex;
    align-items: center;
    color: white;
    height: 20px;
    div {
      line-height: 1;
    }
    svg {
      display: flex;
      width: 7px;
      height: 12px;
      margin-left: 8px;
      path {
        fill: white;
      }
    }
  }
`;

interface ProfileLinkProps {
  userName: string;
}

const ProfileLink = ({ userName }: ProfileLinkProps) => {
  return (
    <Component className="voda_profile_link">
      <DefaultLink to="/myPage">
        <div>{userName} 님</div>
        <IconSMArrowRight />
      </DefaultLink>
    </Component>
  );
};

export default ProfileLink;
